import React, { Component } from 'react';

import PropTypes from 'prop-types';
import ProfileStep from './ProfileStep';
import ValidationErrorMessage from '../../../shared/ValidationErrorMessage';

export default class RetirementAgeStep extends ProfileStep {
  constructor(props) {
    super(props);
    this.state = {
      pristine: true,
      errorMessage: '',
      value: 65,
    };
    this.lifeExpectancy = props.stepConfig.lifeExpectancy;
    this.currentAge = props.stepConfig.currentAge;
  }

  onNext = (e) => {
    e.preventDefault();
    let retirementAge = document.getElementById('profile_retirement_age').value;

    if (this.validate(retirementAge)) {
      if (retirementAge == this.currentAge) {
        this.props.stepConfig.isRetiredHandler(true, true);
      } else {
        this.props.stepConfig.isRetiredHandler(false);
      }
      this.props.onNext();
    } else {
      this.setState({
        pristine: false,
        errorMessage: `Retirement age is not valid`
      });
    }
  }

  validate = (val) => {
    let isValid = val != null && val != '' && val >= this.currentAge && val < this.lifeExpectancy;

    return isValid;
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState({ value: e.target.value })

    if (!this.state.pristine && !this.validate(e.target.value)) {
      this.setState({ errorMessage: `Retirement age is not valid` });
    } else {
      this.setState({ errorMessage: '' });
    }
  }

  render() {
    return (
      <div className="profile-step">
        <h1 className="profile-step__title">{ `Enter your retirement age` }</h1>
        <div className="profile-step__content">
          <form className="simple_form js-onboarding-form onboarding__form" id="edit_profile_3" action="/onboarding/profile" acceptCharset="UTF-8" method="post">
            <p>At what age would you like to retire?</p>
            <input name="utf8" type="hidden" value="✓"/>
            <fieldset className="form__inputs">
              <div className={`form-input integer required profile_retirement_age has-floating-label is-half is-center ${this.state.errorMessage.length > 0 ? 'has-error' : ''}`}>
                <label className="form-control profile_retirement_age">
                  <div className="form-control__label"><span>Retirement age</span> <abbr title="required">*</abbr></div>
                  <div className="form-control__input">
                    <input onChange={this.handleChange} className="numeric integer required" required="required" aria-required="true" type="number" step="1" defaultValue={65} name="profile[retirement_age]" id="profile_retirement_age"/>
                  </div>
                </label>
                <ValidationErrorMessage errorMessage={this.state.errorMessage} />
              </div>
            </fieldset>
          </form>
          <div className='flex flex-col gap-4 mr-12 xs:mr-auto xs:flex xs:flex-row'>
            { this.props.onBack && <button className="button button--secondary profile-step__button" onClick={this.onBack}>Back</button> }
            { this.props.onNext && <button className="button profile-step__button qa-profile-retirement-age" onClick={this.onNext}>Next</button> }
          </div>
        </div>
      </div>
    )
  }
}
